import { ENDPOINT } from "shared/constants/DefaultValues";
import { ResetPasswordData } from "../models/ResetPasswordData";
import { RecoverPasswordResponseError } from "user/pages/RecoverPassword/models/RecoverPasswordResponseError";
import { ValidateTokenData } from "../models/ValidateTokenData";


export const validateRecoverPasswordToken = async (
    validateTokenData: ValidateTokenData,
): Promise<any> => {
    const route = `${ENDPOINT}/usuarios/recoverpassword/validatetoken`;
    const response = await fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(validateTokenData),
    });

    if (!response.ok) {
        const responseData = await response.json();
        throw new RecoverPasswordResponseError(responseData);
    }
};

export const sendResetPassword = async (
    resetPasswordData: ResetPasswordData,
): Promise<any> => {
    const route = `${ENDPOINT}/usuarios/recoverpassword/reset`;
    const response = await fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(resetPasswordData),
    });
    if (!response.ok) {
        const responseData = await response.json();
        throw new RecoverPasswordResponseError(responseData);
    }
};